package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomType
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomRule
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomSeverity
import kotlin.collections.Set
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomStatus
import com.jingfangpai.common.orm.mapping.enums.SyndromeIndicationSignSymptomOwnerType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class SyndromeIndicationSignSymptom(var id: String? = null){
	var syndromeIndicationId: String? = null
	var type: SyndromeIndicationSignSymptomType? = null
	var parentId: String? = null
	var groupName: String? = null
	var symptomId: String? = null
	var rule: SyndromeIndicationSignSymptomRule? = null
	var severity: Set<SyndromeIndicationSignSymptomSeverity>? = null
	var score: Int? = null
	var description: String? = null
	var status: SyndromeIndicationSignSymptomStatus? = null
	var weight: Int? = null
	var source: String? = null
	var sourceContentId: String? = null
	var ownerType: SyndromeIndicationSignSymptomOwnerType? = null
	var ownerId: String? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SyndromeIndicationSignSymptom
		if (id != other.id) return false
		if (syndromeIndicationId != other.syndromeIndicationId) return false
		if (type != other.type) return false
		if (parentId != other.parentId) return false
		if (groupName != other.groupName) return false
		if (symptomId != other.symptomId) return false
		if (rule != other.rule) return false
		if (severity != other.severity) return false
		if (score != other.score) return false
		if (description != other.description) return false
		if (status != other.status) return false
		if (weight != other.weight) return false
		if (source != other.source) return false
		if (sourceContentId != other.sourceContentId) return false
		if (ownerType != other.ownerType) return false
		if (ownerId != other.ownerId) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (syndromeIndicationId?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (parentId?.hashCode() ?: 0)
		result = 31 * result + (groupName?.hashCode() ?: 0)
		result = 31 * result + (symptomId?.hashCode() ?: 0)
		result = 31 * result + (rule?.hashCode() ?: 0)
		result = 31 * result + (severity?.hashCode() ?: 0)
		result = 31 * result + (score?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (source?.hashCode() ?: 0)
		result = 31 * result + (sourceContentId?.hashCode() ?: 0)
		result = 31 * result + (ownerType?.hashCode() ?: 0)
		result = 31 * result + (ownerId?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		return result
	}

}
